// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KqtIZPVgYjq4yixxCs_g{width:100%}.DKbpdHeByslyfin0ERM0,.QlGNT8SFek2DEC8z7lSB{margin-top:40px}.g8t6Wg8fIs0HC_X92bQU{margin-top:24px}.jxCGT2xLq8UuyLtdHe27{flex-direction:column;gap:24px;margin-top:24px;display:flex}.jLZTg1mb7PIDhW6w04bT{font-size:13px;line-height:normal}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `KqtIZPVgYjq4yixxCs_g`,
	"descriptionField": `DKbpdHeByslyfin0ERM0`,
	"useCaseSelect": `QlGNT8SFek2DEC8z7lSB`,
	"descriptionFieldCompact": `g8t6Wg8fIs0HC_X92bQU`,
	"usFields": `jxCGT2xLq8UuyLtdHe27`,
	"fieldText": `jLZTg1mb7PIDhW6w04bT`
};
export default ___CSS_LOADER_EXPORT___;
